import React from 'react';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/footer';
import PodcastSection from '../../components/podcast-section';

export default function Podcasts() {
    return (
        <div className="min-h-screen bg-[#f4f7fa]">
            <Navbar transparent={false} />
            <div className="container mx-auto px-4 pt-24 pb-20">
                <div className="text-center mb-12">
                    <h2 className="text-4xl font-black text-primary-dark uppercase tracking-tight mb-4">Real Estate Podcasts</h2>
                    <p className="text-gray-500 font-bold max-w-2xl mx-auto">Get expert insights, market trends, and investment tips from the industry leaders.</p>
                </div>
                <PodcastSection />
            </div>
            <Footer />
        </div>
    );
}
